// store/modules/labels.js
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        isInit: false,
        labels: {},
    },
    mutations: {
        updateLabels(state, labelsArray) {
            state.labels = labelsArray.reduce((acc, label) => {
                acc[label.id] = label;
                return acc;
            }, {});
        },
        updateIsInit(state, bool) {
            state.isInit = bool;
        },
    },
    getters: {
        getLabels(state) {
            return state.labels;
        },
        getLabelsList(state) {
            return Object.values(state.labels);
        },
    },
    actions: {
        async fetchLabels({ commit }) {
            try {
                const { data } = await axios.get(`${process.env.VUE_APP_API_HOST}/labels`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                });

                commit('updateLabels', data.labels || []);

                try {
                    localStorage.setItem('labels', JSON.stringify(data.labels || []));
                } catch (e) {
                    console.error('localStorage quota exceeded, labels cache not updated:', e);
                }
            } catch (error) {
                console.error('Error fetching labels:', error);
            }
        },

        async init({ dispatch, commit }) {
            const cached = localStorage.getItem('labels');

            if (cached) {
                try {
                    commit('updateLabels', JSON.parse(cached));
                } catch (e) {
                    console.error('Invalid labels cache:', e);
                }
                commit('updateIsInit', true);
                dispatch('fetchLabels');
            } else {
                await dispatch('fetchLabels');
                commit('updateIsInit', true);
            }
        },
    },
};
